var map = {
	"./en-SG": 932,
	"./en-SG.js": 932,
	"./en-au": 933,
	"./en-au.js": 933,
	"./en-ca": 934,
	"./en-ca.js": 934,
	"./en-gb": 935,
	"./en-gb.js": 935,
	"./en-ie": 936,
	"./en-ie.js": 936,
	"./en-il": 937,
	"./en-il.js": 937,
	"./en-nz": 938,
	"./en-nz.js": 938
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2319;


//////////////////
// WEBPACK FOOTER
// ./~/moment/locale en
// module id = 2319
// module chunks = 1